import { render, staticRenderFns } from "./pageDiagnosis4.vue?vue&type=template&id=44da869c&scoped=true"
import script from "./pageDiagnosis4.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis4.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis4.vue?vue&type=style&index=0&id=44da869c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da869c",
  null
  
)

export default component.exports